/////////////////////////////////////////////////////////////////////////////
//  🧊 ENASHA'S FRIDGE — THE ONE FILE YOU EDIT
//
//  Everything on the site reads from this file: names, categories,
//  projects, scene layouts, about + contact.
//
//  HOW TO ADD A PROJECT (the short version):
//    1. add an entry to PROJECTS below
//    2. make sure an object with that project's `objectKey` is standing
//       in the right scene (INTERIOR_SCENE / CATEGORY_SCENES below)
//  Full instructions live in: src/data/EDITING-GUIDE.md
/////////////////////////////////////////////////////////////////////////////

export const SITE = {
  name: "ENASHA THAKKER",
  tagline: "Creative Portfolio",
  hookline: "A creative mind with an appetite for the absurd.\nA lot goes on behind this door.\nGo on. Have a rummage.",
  email: "thakkerenasha@gmail.com",
  phone: "+91 9819225292",
  linkedin: "https://www.linkedin.com/in/enasha-thakker-476b47105",
  linkedinLabel: "CONNECT ON LINKEDIN",
  instagram: "https://www.instagram.com/enasha1411",
  instagramHandle: "@enasha1411",
  londonProject: "https://thakkerenasha.wixsite.com/enasha-thakker-1", // ← the London bus magnet links here
  soundDefault: true,                     // sound on when someone first visits
  photos: {
    doorA: "/photos/thali.jpg",           // left door polaroid
    doorB: "/photos/chai.jpg",            // second door polaroid
    doorC: "/photos/pizza.jpg",           // third door polaroid
    doorD: "/photos/coffee.jpg",          // fourth door polaroid
    about: "/photos/portrait.jpg",        // photo on the About note
  },
};

/////////////////////////////////////////////////////////////////////////////
// THE THREE COMPARTMENTS
/////////////////////////////////////////////////////////////////////////////
export const CATEGORIES = [
  {
    id: "freezer",
    zone: "freezer",
    route: "/freezer",
    kicker: "THE FREEZER",
    title: "COPYWRITING",
    vibe: "cold · controlled · precise",
    blurb: "[ADD ONE LINE ABOUT YOUR COPYWRITING WORK HERE]",
    packageStyle: "frozen",
    dot: "#8FD0EE",
    marquee: ["KEEP FROZEN", "WORDS ON ICE", "DEFROST SLOWLY", "BEST BEFORE: IDEAS"],
  },
  {
    id: "frankenstein",
    zone: "frankenstein",
    route: "/frankenstein",
    kicker: "THE GOOD STUFF",
    title: "CREATIVE DIRECTION",
    vibe: "3AM · chaotic · experimental",
    blurb: "[ADD ONE LINE ABOUT YOUR CREATIVE DIRECTION WORK HERE]",
    packageStyle: "recipe",
    dot: "#E8760C",
    marquee: ["3AM CRAVINGS", "THE GOOD STUFF", "CHIPS INSIDE SANDWICHES", "MIDNIGHT SNACKING"],
  },
  {
    id: "brand-building",
    zone: "drawer",
    route: "/brand-building",
    kicker: "FRUITS & VEGGIES",
    title: "BRANDS WORKED WITH",
    vibe: "fresh · colourful · organic",
    blurb: "[ADD ONE LINE ABOUT YOUR BRAND BUILDING WORK HERE]",
    packageStyle: "grocery",
    dot: "#4F9D4F",
    marquee: ["FARM FRESH BRANDS", "HAND-PICKED IDEAS", "SOLD BY THE KILO", "LOCALLY GROWN"],
  },
];

/////////////////////////////////////////////////////////////////////////////
// PROJECTS — 3 clearly-labelled placeholders per compartment.
// copy one of these blocks to add your real work.
/////////////////////////////////////////////////////////////////////////////
export const PROJECTS = [
  // ---------- FREEZER / COPYWRITING ----------
  {
    id: "copy-01",
    category: "freezer",
    objectKey: "ice-cream",
    objectLabel: "ICE CREAM",
    title: "Copywriting Project 01",
    status: "PLACEHOLDER",
    tagline: "[ADD A ONE-LINE HOOK FOR THIS PROJECT]",
    description:
      "[ADD A SHORT DESCRIPTION OF THIS PROJECT. WHAT WAS THE BRIEF, WHAT DID YOU WRITE, WHY DOES IT MATTER?]",
    heroImage: null,            // ← paste an image URL, or drop a file into /public and use "/yourfile.jpg"
    gallery: [null, null],      // ← more images
    video: null,                // ← paste a video/gif URL
    process: "[ADD YOUR PROCESS — DRAFTS, EDITS, IDEAS THAT DIED ALONG THE WAY]",
    research: "[ADD RESEARCH / REFERENCE / STRATEGY NOTES]",
    outcome: "[ADD THE OUTCOME — RESULTS, REACH, REACTIONS]",
    instagram: "",              // ← direct instagram post link (optional)
    externalLink: "",           // ← any external link (optional)
    credits: "[ADD CREDITS — COLLABORATORS, AGENCIES]",
    year: "[YEAR]",
    client: "[CLIENT / ORGANISATION]",
  },
  {
    id: "copy-02",
    category: "freezer",
    objectKey: "frozen-fish",
    objectLabel: "FROZEN FISH",
    title: "Copywriting Project 02",
    status: "PLACEHOLDER",
    tagline: "[ADD A ONE-LINE HOOK FOR THIS PROJECT]",
    description: "[ADD A SHORT DESCRIPTION OF THIS PROJECT]",
    heroImage: null,
    gallery: [null, null],
    video: null,
    process: "[ADD YOUR PROCESS]",
    research: "[ADD RESEARCH NOTES]",
    outcome: "[ADD THE OUTCOME]",
    instagram: "",
    externalLink: "",
    credits: "[ADD CREDITS]",
    year: "[YEAR]",
    client: "[CLIENT]",
  },
  {
    id: "copy-03",
    category: "freezer",
    objectKey: "peas-packet",
    objectLabel: "FROZEN PEAS",
    title: "Copywriting Project 03",
    status: "PLACEHOLDER",
    tagline: "[ADD A ONE-LINE HOOK FOR THIS PROJECT]",
    description: "[ADD A SHORT DESCRIPTION OF THIS PROJECT]",
    heroImage: null,
    gallery: [null, null],
    video: null,
    process: "[ADD YOUR PROCESS]",
    research: "[ADD RESEARCH NOTES]",
    outcome: "[ADD THE OUTCOME]",
    instagram: "",
    externalLink: "",
    credits: "[ADD CREDITS]",
    year: "[YEAR]",
    client: "[CLIENT]",
  },

  // ---------- MAIN FRIDGE / CREATIVE DIRECTION ----------
  {
    id: "cd-01",
    category: "frankenstein",
    objectKey: "sandwich",
    objectLabel: "OVERLOADED SANDWICH",
    title: "Creative Direction Project 01",
    status: "PLACEHOLDER",
    tagline: "[ADD A ONE-LINE HOOK FOR THIS PROJECT]",
    description: "[ADD A SHORT DESCRIPTION OF THIS PROJECT]",
    heroImage: null,
    gallery: [null, null],
    video: null,
    process: "[ADD YOUR PROCESS]",
    research: "[ADD RESEARCH NOTES]",
    outcome: "[ADD THE OUTCOME]",
    instagram: "",
    externalLink: "",
    credits: "[ADD CREDITS]",
    year: "[YEAR]",
    client: "[CLIENT]",
  },
  {
    id: "cd-02",
    category: "frankenstein",
    objectKey: "roast-chicken",
    objectLabel: "ROAST CHICKEN",
    title: "Creative Direction Project 02",
    status: "PLACEHOLDER",
    tagline: "[ADD A ONE-LINE HOOK FOR THIS PROJECT]",
    description: "[ADD A SHORT DESCRIPTION OF THIS PROJECT]",
    heroImage: null,
    gallery: [null, null],
    video: null,
    process: "[ADD YOUR PROCESS]",
    research: "[ADD RESEARCH NOTES]",
    outcome: "[ADD THE OUTCOME]",
    instagram: "",
    externalLink: "",
    credits: "[ADD CREDITS]",
    year: "[YEAR]",
    client: "[CLIENT]",
  },
  {
    id: "cd-03",
    category: "frankenstein",
    objectKey: "cheese-wheel",
    objectLabel: "WHEEL OF CHEESE",
    title: "Creative Direction Project 03",
    status: "PLACEHOLDER",
    tagline: "[ADD A ONE-LINE HOOK FOR THIS PROJECT]",
    description: "[ADD A SHORT DESCRIPTION OF THIS PROJECT]",
    heroImage: null,
    gallery: [null, null],
    video: null,
    process: "[ADD YOUR PROCESS]",
    research: "[ADD RESEARCH NOTES]",
    outcome: "[ADD THE OUTCOME]",
    instagram: "",
    externalLink: "",
    credits: "[ADD CREDITS]",
    year: "[YEAR]",
    client: "[CLIENT]",
  },
  {
    id: "cd-04",
    category: "frankenstein",
    objectKey: "chocolate-cake",
    objectLabel: "CHOCOLATE CAKE",
    title: "Creative Direction Project 04",
    status: "PLACEHOLDER",
    tagline: "[ADD A ONE-LINE HOOK FOR THIS PROJECT]",
    description: "[ADD A SHORT DESCRIPTION OF THIS PROJECT]",
    heroImage: null,
    gallery: [null, null],
    video: null,
    process: "[ADD YOUR PROCESS]",
    research: "[ADD RESEARCH NOTES]",
    outcome: "[ADD THE OUTCOME]",
    instagram: "",
    externalLink: "",
    credits: "[ADD CREDITS]",
    year: "[YEAR]",
    client: "[CLIENT]",
  },
  {
    id: "cd-05",
    category: "frankenstein",
    objectKey: "milk-packet",
    objectLabel: "MILK",
    title: "Creative Direction Project 05",
    status: "PLACEHOLDER",
    tagline: "[ADD A ONE-LINE HOOK FOR THIS PROJECT]",
    description: "[ADD A SHORT DESCRIPTION OF THIS PROJECT]",
    heroImage: null,
    gallery: [null, null],
    video: null,
    process: "[ADD YOUR PROCESS]",
    research: "[ADD RESEARCH NOTES]",
    outcome: "[ADD THE OUTCOME]",
    instagram: "",
    externalLink: "",
    credits: "[ADD CREDITS]",
    year: "[YEAR]",
    client: "[CLIENT]",
  },
  {
    id: "cd-06",
    category: "frankenstein",
    objectKey: "candy-jar",
    objectLabel: "CANDY JAR",
    title: "Creative Direction Project 06",
    status: "PLACEHOLDER",
    tagline: "[ADD A ONE-LINE HOOK FOR THIS PROJECT]",
    description: "[ADD A SHORT DESCRIPTION OF THIS PROJECT]",
    heroImage: null,
    gallery: [null, null],
    video: null,
    process: "[ADD YOUR PROCESS]",
    research: "[ADD RESEARCH NOTES]",
    outcome: "[ADD THE OUTCOME]",
    instagram: "",
    externalLink: "",
    credits: "[ADD CREDITS]",
    year: "[YEAR]",
    client: "[CLIENT]",
  },

  // ---------- FRUIT & VEG DRAWER / BRAND BUILDING ----------
  {
    id: "brand-01",
    category: "brand-building",
    objectKey: "lemon",
    objectLabel: "BOWL OF LEMONS",
    title: "Brand Project 01",
    status: "PLACEHOLDER",
    tagline: "[ADD A ONE-LINE HOOK FOR THIS PROJECT]",
    description: "[ADD A SHORT DESCRIPTION OF THIS PROJECT]",
    heroImage: null,
    gallery: [null, null],
    video: null,
    process: "[ADD YOUR PROCESS]",
    research: "[ADD RESEARCH NOTES]",
    outcome: "[ADD THE OUTCOME]",
    instagram: "",
    externalLink: "",
    credits: "[ADD CREDITS]",
    year: "[YEAR]",
    client: "[CLIENT]",
  },
  {
    id: "brand-02",
    category: "brand-building",
    objectKey: "chilli",
    objectLabel: "GREEN CHILLI",
    title: "Brand Project 02",
    status: "PLACEHOLDER",
    tagline: "[ADD A ONE-LINE HOOK FOR THIS PROJECT]",
    description: "[ADD A SHORT DESCRIPTION OF THIS PROJECT]",
    heroImage: null,
    gallery: [null, null],
    video: null,
    process: "[ADD YOUR PROCESS]",
    research: "[ADD RESEARCH NOTES]",
    outcome: "[ADD THE OUTCOME]",
    instagram: "",
    externalLink: "",
    credits: "[ADD CREDITS]",
    year: "[YEAR]",
    client: "[CLIENT]",
  },
  {
    id: "brand-03",
    category: "brand-building",
    objectKey: "tomato",
    objectLabel: "TOMATO",
    title: "Brand Project 03",
    status: "PLACEHOLDER",
    tagline: "[ADD A ONE-LINE HOOK FOR THIS PROJECT]",
    description: "[ADD A SHORT DESCRIPTION OF THIS PROJECT]",
    heroImage: null,
    gallery: [null, null],
    video: null,
    process: "[ADD YOUR PROCESS]",
    research: "[ADD RESEARCH NOTES]",
    outcome: "[ADD THE OUTCOME]",
    instagram: "",
    externalLink: "",
    credits: "[ADD CREDITS]",
    year: "[YEAR]",
    client: "[CLIENT]",
  },
];

/////////////////////////////////////////////////////////////////////////////
// SCENES — where every object stands inside the fridge & category pages.
// key : object id from src/components/objects/registry.js
// x   : horizontal position, % of the zone width
// y   : BASELINE of the object, % of the zone height — objects stand ON
//       the shelf lines / floor at this height (nothing floats!)
// s   : size multiplier (1 = default 72px)
// rot : resting tilt in degrees
// deco: true = pure decoration (no project attached)
/////////////////////////////////////////////////////////////////////////////
export const INTERIOR_SCENE = {
  freezer: [
    { key: "frozen-fish", x: 30, y: 92, s: 1.55, rot: -3 },
    { key: "ice-cream", x: 56, y: 94, s: 1.4, rot: 2 },
    { key: "peas-packet", x: 76, y: 92, s: 1.2, rot: -4 },
  ],
  shelves: [
    // row 1 — BIG, crowded, spilling off the edges
    { key: "peanut-butter", x: -2, y: 40, s: 1.15, rot: -5, deco: true },
    { key: "ketchup-spill", x: 26, y: 40, s: 0.9, rot: 0, deco: true },
    { key: "soda-can", x: 34, y: 40, s: 1.0, rot: 6, deco: true },
    { key: "watermelon-slice", x: 84, y: 40, s: 1.25, rot: 4, deco: true },
    { key: "sandwich", x: 10, y: 40, s: 1.7, rot: -3 },
    { key: "roast-chicken", x: 38, y: 40, s: 1.85, rot: 1 },
    { key: "cheese-wheel", x: 64, y: 40, s: 1.7, rot: -2 },
    // row 2 — packed tight, mustard drip, milk puddle
    { key: "steel-dabba", x: -2, y: 85, s: 1.15, rot: 4, deco: true },
    { key: "mustard-spill", x: 30, y: 85, s: 0.85, rot: 0, deco: true },
    { key: "juice-carton", x: 33, y: 85, s: 1.1, rot: -4, deco: true },
    { key: "milk-spill", x: 92, y: 85, s: 0.8, rot: 0, deco: true },
    { key: "pastry", x: 84, y: 85, s: 1.15, rot: 8, deco: true },
    { key: "chocolate-cake", x: 10, y: 85, s: 1.7, rot: 2 },
    { key: "milk-packet", x: 44, y: 85, s: 1.4, rot: -2 },
    { key: "candy-jar", x: 63, y: 85, s: 1.55, rot: 3 },
  ],
  drawer: [
    // back heap — standing deeper inside the bin
    { key: "apple", x: 4, y: 58, s: 0.9, rot: -3, deco: true },
    { key: "orange", x: 17, y: 56, s: 0.88, rot: 2, deco: true },
    { key: "onion", x: 30, y: 58, s: 0.85, rot: -4, deco: true },
    { key: "potato", x: 43, y: 59, s: 0.82, rot: 3, deco: true },
    { key: "broccoli", x: 56, y: 56, s: 0.95, rot: 2, deco: true },
    { key: "capsicum", x: 69, y: 58, s: 0.88, rot: -3, deco: true },
    { key: "coriander-bunch", x: 83, y: 57, s: 0.85, rot: 3, deco: true },
    // front heap — tumbled at the front of the bin
    { key: "lettuce", x: 1, y: 93, s: 1.45, rot: -4, deco: true },
    { key: "lemon", x: 18, y: 94, s: 0.95, rot: -4 },
    { key: "tomato", x: 32, y: 93, s: 1.15, rot: 2 },
    { key: "bananas", x: 47, y: 92, s: 1.4, rot: -3, deco: true },
    { key: "chilli", x: 68, y: 94, s: 0.9, rot: 8 },
    { key: "carrot", x: 82, y: 93, s: 1.2, rot: -8, deco: true },
  ],
};

/////////////////////////////////////////////////////////////////////////////
// DOOR_SCENE — the inside of the open door: 3 racks (0 = top).
// x : horizontal position, % of the door width · objects stand on the rack line
/////////////////////////////////////////////////////////////////////////////
export const DOOR_SCENE = [
  // top rack — breakfast things
  { key: "egg-tray", rack: 0, x: 2, s: 1.2, rot: -3, deco: true },
  { key: "butter-tub", rack: 0, x: 55, s: 1.05, rot: 4, deco: true },
  { key: "curd-container", rack: 0, x: 78, s: 0.95, rot: -2, deco: true },
  // middle rack — sauces & sips
  { key: "sauce-bottle", rack: 1, x: 4, s: 1.15, rot: -4, deco: true },
  { key: "soda-can", rack: 1, x: 38, s: 1.0, rot: 3, deco: true },
  { key: "juice-carton", rack: 1, x: 64, s: 1.15, rot: -3, deco: true },
  // bottom rack — tall drinks
  { key: "milk-carton", rack: 2, x: 3, s: 1.25, rot: 2, deco: true },
  { key: "soda-bottle", rack: 2, x: 38, s: 1.2, rot: -4, deco: true },
  { key: "water-bottle", rack: 2, x: 69, s: 1.2, rot: 3, deco: true },
];

export const CATEGORY_SCENES = {
  freezer: [
    { key: "frozen-fish", x: 12, y: 92, s: 2.0, rot: -3 },
    { key: "ice-cream", x: 44, y: 94, s: 1.8, rot: 2 },
    { key: "peas-packet", x: 70, y: 92, s: 1.5, rot: -4 },
  ],
  frankenstein: [
    // top shelf — big, crowded, spilling
    { key: "peanut-butter", x: 1, y: 50, s: 1.2, rot: -4, deco: true },
    { key: "ketchup-spill", x: 28, y: 50, s: 0.95, rot: 0, deco: true },
    { key: "soda-can", x: 33, y: 50, s: 1.05, rot: 5, deco: true },
    { key: "watermelon-slice", x: 72, y: 50, s: 1.55, rot: 3, deco: true },
    { key: "juice-carton", x: 88, y: 50, s: 1.1, rot: -5, deco: true },
    { key: "sandwich", x: 9, y: 50, s: 1.75, rot: -3 },
    { key: "roast-chicken", x: 35, y: 50, s: 1.9, rot: 1 },
    { key: "cheese-wheel", x: 57, y: 50, s: 1.75, rot: -2 },
    // floor row — packed tight, messy
    { key: "steel-dabba", x: 1, y: 94, s: 1.2, rot: 4, deco: true },
    { key: "mustard-spill", x: 30, y: 94, s: 0.9, rot: 0, deco: true },
    { key: "layer-dessert", x: 33, y: 94, s: 1.25, rot: 3, deco: true },
    { key: "achaar-jar", x: 76, y: 94, s: 1.15, rot: -4, deco: true },
    { key: "pastry", x: 88, y: 94, s: 1.25, rot: 8, deco: true },
    { key: "chocolate-cake", x: 11, y: 94, s: 1.75, rot: 2 },
    { key: "milk-packet", x: 44, y: 94, s: 1.45, rot: -2 },
    { key: "candy-jar", x: 60, y: 94, s: 1.6, rot: 3 },
  ],
  drawer: [
    // back heap
    { key: "apple", x: 4, y: 66, s: 1.05, rot: -3, deco: true },
    { key: "orange", x: 17, y: 64, s: 1.0, rot: 2, deco: true },
    { key: "onion", x: 30, y: 66, s: 0.95, rot: -4, deco: true },
    { key: "potato", x: 42, y: 67, s: 0.95, rot: 3, deco: true },
    { key: "broccoli", x: 54, y: 64, s: 1.0, rot: 2, deco: true },
    { key: "capsicum", x: 66, y: 66, s: 0.95, rot: -3, deco: true },
    { key: "coriander-bunch", x: 78, y: 65, s: 0.9, rot: -3, deco: true },
    { key: "carrot", x: 89, y: 67, s: 0.9, rot: -8, deco: true },
    // front heap
    { key: "lettuce", x: 6, y: 93, s: 1.05, rot: -4, deco: true },
    { key: "lemon", x: 20, y: 94, s: 1.05, rot: -5 },
    { key: "tomato", x: 38, y: 93, s: 1.05, rot: 0 },
    { key: "bananas", x: 56, y: 92, s: 1.0, rot: -3, deco: true },
    { key: "chilli", x: 74, y: 94, s: 0.95, rot: 10 },
  ],
};

/////////////////////////////////////////////////////////////////////////////
// COPYWRITING PAGE (/freezer) — hand-picked posts, three rows.
// Each post: title + link (Instagram URL) + image (cover/thumbnail, optional).
// Add a post: copy one { } block and fill it in. Delete a post: remove the block.
/////////////////////////////////////////////////////////////////////////////
export const COPYWRITING_PAGE = {
  kicker: "THE FREEZER",
  title: "COPYWRITING",
  context: "Welcome to the freezer. A little collection of my favourite copywriting concoctions, now frozen in time (and hopefully not in creativity). From carousels and statics to reel scripts, these are some of the pieces I've had the most fun working on. Pick whatever catches your eye, give it a click, and you'll be taken straight to the brand's Instagram to see it entirely.",
  rows: [
    {
      id: "carousels",
      label: "CAROUSELS",
      shape: "cube", // ice cube backdrops (square)
      posts: [
        { title: "we know what you ate last night and we need to talk", image: "/uploads/freezer/carousels-01.jpg", link: "https://www.instagram.com/p/DYhTmhOCGme/" },
        { title: "boss caught you shopping on the NYKAA HOT PINK SALE? Try saying these", image: "/uploads/freezer/carousels-02.jpg", link: "https://www.instagram.com/p/DbGF_uKDLzq/" },
        { title: "It's a piece of cake not having cakey makeup if you prep your skin right", image: "/uploads/freezer/carousels-03.jpg", link: "https://www.instagram.com/p/DWvTqfKDMW_/" },
        { title: "your skin wakes up hungry — What's for breakfast?", image: "/uploads/freezer/carousels-04.jpg", link: "https://www.instagram.com/p/DWTALJxDEim/" },
        { title: "TOP SECRET — ALL CLUES COUNT BUT ONLY ONE LEADS TO THE TRUTH", image: "/uploads/freezer/carousels-05.jpg", link: "https://www.instagram.com/p/DSonqktDLD4/" },
        { title: "So you're too lazy to do you PM Routine huh? *rolls eyes*", image: "/uploads/freezer/carousels-06.jpg", link: "https://www.instagram.com/p/DZUzEC9jCCS/" },
        { title: "colder than your ex's heart…", image: "/uploads/freezer/carousels-07.jpg", link: "https://www.instagram.com/p/DWaiOo5iLWi/" },
        { title: "your child is not your therapist", image: "/uploads/freezer/carousels-08.jpg", link: "https://www.instagram.com/p/DUGEJc2kgAh/" },
        { title: "Navigating loss and Grief with your children", image: "/uploads/freezer/carousels-09.jpg", link: "https://www.instagram.com/p/DVGc-BtEpRs/" },
        { title: "you need to stop ghosting people", image: "/uploads/freezer/carousels-10.jpg", link: "https://www.instagram.com/p/DXRGZ5gADj1/" },
        { title: "we have always dreamt of summer body but what about summer skin?", image: "/uploads/freezer/carousels-11.jpg", link: "https://www.instagram.com/p/DYMM1O-gA1J/" },
        { title: "hot girls don't skip Holi, they buy TONYMOLY", image: "/uploads/freezer/carousels-12.jpg", link: "https://www.instagram.com/p/DVYfRP4jFml/" },
        { title: "Holi SH*T the colour came right off", image: "/uploads/freezer/carousels-13.jpg", link: "https://www.instagram.com/p/DVWLe8gEz4G/" },
        { title: "the sunscreen that blue our mind and we're sure will blow yours too", image: "/uploads/freezer/carousels-14.jpg", link: "https://www.instagram.com/p/DXhD9dkE9VN/" },
        { title: "cloudy with a chance of skipping sunscreen? Absolutely not.", image: "/uploads/freezer/carousels-15.jpg", link: "https://www.instagram.com/p/DZ7dpvXgKWf/" },
        { title: "ever wondered what's actually going inside our flavours? Meet the crew…", image: "/uploads/freezer/carousels-16.jpg", link: "https://www.instagram.com/p/DZCy4kCiGa0/" },
        { title: "What is Brushers Co.? Jasmine Mint", image: "/uploads/freezer/carousels-17.jpg", link: "https://www.instagram.com/p/DVxPz19DzSj/" },
      ],
    },
    {
      id: "reels",
      label: "REELS & SCRIPTS",
      shape: "lolly", // ice lolly backdrops (vertical)
      posts: [
        { title: "girl holding a box of products — @shubhra.vaity", image: "/uploads/freezer/reels-01.jpg", link: "https://www.instagram.com/reel/DYM19F_teWh/" },
        { title: "today is day one and this summer", image: "/uploads/freezer/reels-02.jpg", link: "https://www.instagram.com/reel/DYRQLHmga0b/" },
        { title: "that one rich aunty we all know", image: "/uploads/freezer/reels-03.jpg", link: "https://www.instagram.com/reel/DUnsvckiXCD/" },
        { title: "Things 2 do in Mumbai — THE ULTIMATE RAGER", image: "/uploads/freezer/reels-04.jpg", link: "https://www.instagram.com/reel/DbLvCwWBnUP/" },
        { title: "Things 2 do in Mumbai — MEET THE KING", image: "/uploads/freezer/reels-05.jpg", link: "https://www.instagram.com/reel/DbIvTo9y9F_/" },
        { title: "fu*k nazar dude", image: "/uploads/freezer/reels-06.jpg", link: "https://www.instagram.com/reel/DUfomvnDShY/" },
        { title: "Honestly, ******** Nazar, right?", image: "/uploads/freezer/reels-07.jpg", link: "https://www.instagram.com/reel/DUUwVKwDHgA/" },
        { title: "North Pole Station — reindeer heads lead the way", image: "/uploads/freezer/reels-08.jpg", link: "https://www.instagram.com/reel/DSjYZlaDN1J/" },
        { title: "female Santa, hands on head, shocked", image: "/uploads/freezer/reels-09.jpg", link: "https://www.instagram.com/reel/DSl0gQbk3Jh/" },
        { title: "TERRAPY cooking show", image: "/uploads/freezer/reels-10.jpg", link: "https://www.instagram.com/reel/Dcv05YqMgmN/" },
        { title: "good one — dog on the cover", image: "/uploads/freezer/reels-11.jpg", link: "https://www.instagram.com/reel/DY7NwadIfs_/" },
        { title: "that's why we just call it", image: "/uploads/freezer/reels-12.jpg", link: "https://www.instagram.com/reel/DXqoemfDKMf/" },
        { title: "somewhere to be", image: "/uploads/freezer/reels-13.jpg", link: "https://www.instagram.com/reel/DclS2Y5sZi4/" },
        { title: "papa yarrrr…", image: "/uploads/freezer/reels-14.jpg", link: "https://www.instagram.com/reel/DZhNgOQIqrC/" },
        { title: "the biriyani masala", image: "/uploads/freezer/reels-15.jpg", link: "https://www.instagram.com/reel/DRKZlMTCDSp/" },
        { title: "All I want for Christmas is youuu", image: "/uploads/freezer/reels-16.jpg", link: "https://www.instagram.com/reel/DSpZIIZkaUl/" },
        { title: "this is insane", image: "/uploads/freezer/reels-17.jpg", link: "https://www.instagram.com/reel/DYZmFV9sGW7/" },
        { title: "Saturday mornings as a 23 year old couple", image: "/uploads/freezer/reels-18.jpg", link: "https://www.instagram.com/reel/DYUXs_0INtW/" },
        { title: "before you pick your toothpaste?", image: "/uploads/freezer/reels-19.jpg", link: "https://www.instagram.com/reel/DZH8AgyTh3U/" },
        { title: "ginger mint — Brushers Co. orange toothpaste", image: "/uploads/freezer/reels-20.jpg", link: "https://www.instagram.com/reel/DbTBemuhAGk/" },
        { title: "smile hotline", image: "/uploads/freezer/reels-21.jpg", link: "https://www.instagram.com/reel/DbnnzUfo7hU/" },
        { title: "Biriyani Bytes", image: "/uploads/freezer/reels-22.jpg", link: "https://www.instagram.com/reel/DMkcBctNy4T/" },
        { title: "your mother who somehow knows", image: "/uploads/freezer/reels-23.jpg", link: "https://www.instagram.com/reel/DbsnDU4uyje/" },
        { title: "what it's like working in a women-led office", image: "/uploads/freezer/reels-24.jpg", link: "https://www.instagram.com/reel/Db3CKRoKZGN/" },
        { title: "The Biggest in the forest", image: "/uploads/freezer/reels-25.jpg", link: "https://www.instagram.com/reel/DU-yLHaDCTQ/" },
      ],
    },
    {
      id: "statics",
      label: "STATICS",
      shape: "cube",
      posts: [
        { title: "sugar, spice and everything nice", image: "/uploads/freezer/statics-01.jpg", link: "https://www.instagram.com/p/DWbhgx0jBJT/" },
        { title: "what first love feels like", image: "/uploads/freezer/statics-02.jpg", link: "https://www.instagram.com/p/DWB4I-uDBC4/" },
        { title: "Crime scene — crime committed: wearing killer shoes", image: "/uploads/freezer/statics-03.jpg", link: "https://www.instagram.com/p/DQ1ft77DVpp/" },
        { title: "Crafted for the Modern Maharani", image: "/uploads/freezer/statics-04.jpg", link: "https://www.instagram.com/p/DNlFYyyo-eg/" },
      ],
    },
  ],
};

/////////////////////////////////////////////////////////////////////////////
// GOOD STUFF — creative direction page: 3 project spaces (video + text + gallery)
/////////////////////////////////////////////////////////////////////////////
export const GOODSTUFF_PAGE = {
  kicker: "THE GOOD STUFF",
  title: "CREATIVE DIRECTION",
  context: "Welcome to the middle shelf: home to half-eaten meals, questionable combinations and the occasional stroke of genius. It's where random bits and pieces come together to make something surprisingly good. Here's a peek at how I think, create and bring ideas to life. Go on, take a bite!",
  projects: [
    {
      id: "project-1",
      title: "LEGO (MINIFIGURES SERIES)",
      tagline: "Mini Yet Mighty!",
      video: null, // user chose cover + "watch the film" link instead of embeds
      poster: "/uploads/freezer/project-1-film-cover.jpg",
      link: "https://www.instagram.com/reel/DcOPzadv3q4/",
      text: "They're tiny, they're plastic, and yet, they have more personality than most of us here. I got the chance of a lifetime to work on the scripting and creative direction for LEGO's Minifigures series, coming up with playful ways to bring these little characters to life through social content. I was also on the ground for the store launch, helping capture the buzz, creator interactions and excitement as the doors opened.",
      gallery: [
        { image: "/uploads/gallery/lego-01.jpg", link: "https://www.instagram.com/reel/DbDtqJLSpNy/" },
        { image: "/uploads/gallery/lego-02.jpg", link: "https://www.instagram.com/reel/DbFc1zAB7mU/" },
        { image: "/uploads/gallery/lego-03.jpg", link: "https://www.instagram.com/reel/DbHfSwJBzJe/" },
        { image: "/uploads/gallery/lego-04.jpg", link: "https://www.instagram.com/reel/DbIvTo9y9F_/" },
        { image: "/uploads/gallery/lego-05.jpg", link: "https://www.instagram.com/reel/DbLvCwWBnUP/" },
        { image: "/uploads/gallery/lego-06.jpg", link: "https://www.instagram.com/reel/DbOHP3aornb/" },
        { image: "/uploads/gallery/lego-07.jpg", link: "https://www.instagram.com/reel/DbgP5yyydS7/" },
        { image: "/uploads/gallery/lego-bts-01.jpg", link: "" },
        { image: "/uploads/gallery/lego-bts-02.jpg", link: "" },
        { image: "/uploads/gallery/lego-bts-03.jpg", link: "" },
        { image: "/uploads/gallery/lego-bts-04.jpg", link: "" },
      ],
    },
    {
      id: "project-2",
      title: "BRUSHERS CO.",
      tagline: "Brush past the boring!",
      video: null,
      poster: "/uploads/freezer/project-2-film-cover.jpg",
      link: "https://www.instagram.com/reel/DYUwwCwMAPD/",
      text: "Imagine launching a brand that nobody's heard of yet. No established identity, no existing presence, just a whole lot of potential. I worked on the go-to-market strategy and co-directed an outdoor product shoot spanning locations across Mumbai, helping build the visual foundation for the brand's launch. The job was to create a world for the brand before the world knew it existed. From shaping its first impression to translating its positioning, it was a whole brand debut, from scratch. And in the first five days of launch, we clocked 100 sales (not to brag, hehe).",
      gallery: [
        { image: "/uploads/gallery/brushers-01.jpg", link: "https://www.instagram.com/p/DV8n6GKDMWv/" },
        { image: "/uploads/gallery/brushers-02.jpg", link: "https://www.instagram.com/p/DV_OmLekxKI/" },
        { image: "/uploads/gallery/brushers-03.jpg", link: "https://www.instagram.com/p/DWJfLPDk7W0/" },
        { image: "/uploads/gallery/brushers-04.jpg", link: "https://www.instagram.com/p/DWMEWcvDPnR/" },
        { image: "/uploads/gallery/brushers-05.jpg", link: "https://www.instagram.com/p/DWROM8Lk4V0/" },
        { image: "/uploads/gallery/brushers-06.jpg", link: "https://www.instagram.com/p/DWaiOo5iLWi/" },
        { image: "/uploads/gallery/brushers-07.jpg", link: "https://www.instagram.com/p/DWgTEFSjFpV/" },
        { image: "/uploads/gallery/brushers-bts-01.jpg", link: "" },
        { image: "/uploads/gallery/brushers-bts-02.jpg", link: "" },
      ],
    },
    {
      id: "project-3",
      title: "TONYMOLY",
      tagline: "The Case of the Missing Glow",
      video: null,
      poster: "/uploads/freezer/project-3-film-cover.jpg",
      link: "https://www.instagram.com/reel/DTIVHvoDMS5/",
      text: "Christmas campaigns had become a little predictable: Mariah Carey on repeat, a few festive offers, and a Santa hat slapped on everything. We wanted to bring back the real magic of Christmas, getting everyone together, and what better way to do that than with a good old-fashioned whodunnit? I worked on the concept, scripting and creative direction for TONYMOLY's interactive Christmas mystery, where the mission was to save Christmas by figuring out who stole Mrs Claus's TONYMOLY products. With suspicious characters and clues scattered across social media, we gave audiences a mystery to solve instead of just another festive ad to scroll past.",
      gallery: [
        { image: "/uploads/gallery/tonymoly-01.jpg", link: "https://www.instagram.com/p/DSgzIYpk2xr/" },
        { image: "/uploads/gallery/tonymoly-02.jpg", link: "https://www.instagram.com/reel/DSjYZlaDN1J/" },
        { image: "/uploads/gallery/tonymoly-03.jpg", link: "https://www.instagram.com/reel/DSl0gQbk3Jh/" },
        { image: "/uploads/gallery/tonymoly-04.jpg", link: "https://www.instagram.com/p/DSonqktDLD4/" },
        { image: "/uploads/gallery/tonymoly-05.jpg", link: "https://www.instagram.com/reel/DSpZIIZkaUl/" },
        { image: "/uploads/gallery/tonymoly-06.jpg", link: "https://www.instagram.com/reel/DSpf0cXjOwl/" },
        { image: "/uploads/gallery/tonymoly-07.jpg", link: "https://www.instagram.com/reel/DSrQzIPk9NX/" },
        { image: "/uploads/gallery/tonymoly-bts-01.jpg", link: "" },
        { image: "/uploads/gallery/tonymoly-bts-02.jpg", link: "" },
      ],
    },
  ],
};

/////////////////////////////////////////////////////////////////////////////
// BRANDS — brands worked with: fun logo sticker wall (logos + links coming)
/////////////////////////////////////////////////////////////////////////////
export const BRANDS_PAGE = {
  kicker: "FRUITS & VEGGIES",
  title: "BRANDS WORKED WITH",
  context: "Welcome to the 'fruits and veggies' drawer, where no two things are quite alike. From skincare to food and everything in between, I've worked with brands across a colourful mix of sectors, each bringing something different to the table. Think of this as my little harvest of collaborations, ideas and creative adventures.",
  logos: [
    { name: "TONYMOLY India", image: "/uploads/logos/tonymoly.jpg", link: "https://www.instagram.com/tonymoly.in_official/" },
    { name: "Nykaa Luxe", image: "/uploads/logos/nykaaluxe.jpg", link: "https://www.instagram.com/nykaaluxe/" },
    { name: "terrapy", image: "/uploads/logos/terrapy.jpg", link: "https://www.instagram.com/letsterrapy/" },
    { name: "LEGO", image: "/uploads/logos/mybrickhouse.jpg", link: "https://www.instagram.com/lego.mybrickhouse/" },
    { name: "Brushers Co.", image: "/uploads/logos/brushers.jpg", link: "https://www.instagram.com/brushers.co/" },
    { name: "Niti Shah Jewels", image: "/uploads/logos/nitishahjewels.jpg", link: "https://www.instagram.com/nitishahjewels/" },
    { name: "Periwinkle", image: "/uploads/logos/periwinkle.jpg", link: "https://www.instagram.com/periwinkle_kids/" },
    { name: "Mehfil Biriyani", image: "/uploads/logos/mehfilbiriyani.jpg", link: "https://www.instagram.com/mehfilbiriyani_uae/" },
    { name: "Hyro Realty", image: "/uploads/logos/hyro.jpg", link: "https://www.instagram.com/hyro_realty/" },
    { name: "The Bridal Affair India", image: "/uploads/logos/bridalaffair.jpg", link: "https://www.instagram.com/bridalaffairind/" },
    { name: "L'Echo Bombay", image: "/uploads/logos/lecho.jpg", link: "https://www.instagram.com/lechobombay/" },
    { name: "Charism Image Management", image: "/uploads/logos/charism.jpg", link: "https://www.instagram.com/charismimagemanagement/" },
  ],
};

/////////////////////////////////////////////////////////////////////////////
// ABOUT — the note stuck to the fridge door
/////////////////////////////////////////////////////////////////////////////
export const ABOUT = {
  heading: "GET TO KNOW ME",
  sub: "you know you want to",
  photo: "/photos/portrait.jpg",
  sections: [
    {
      label: "ABOUT ME",
      text: "Copywriter, food connoisseur and occasional over-thinker — the holy trifecta. Trained in visual communication, with a soft spot for film, theatre and any form of storytelling. A recent interest in creative direction and creative strategy.",
    },
    {
      label: "EDUCATION",
      lines: [
        "Royal College of Art, London — MA Visual Communication, Merit (2023–24)",
        "University of the Arts London — PG Diploma, Graphic Design Communication, Merit (2022–23)",
        "ISDI, Mumbai — PG Diploma, Graphic Design (2019–20)",
        "FLAME University, Pune — BBA, Communication Management (Advertising & Branding), GPA 8.40 (2016–19)",
      ],
    },
    {
      label: "EXPERIENCE",
      lines: [
        "Scribbld Social — Creative Writing Executive (2025–26): worked across 9 brands, juggled 5 accounts at a time, led 5 pitches and turned briefs into campaigns, content and shoots. From TONYMOLY to LEGO, there was rarely a dull moment.",
        "Refine — Social Media Manager (2020–21): managed social media for 7 clients, helped grow followers by 40% on key accounts and brought in 5 new clients.",
        "Earlier adventures — Indigo Consultations & AdFactors PR (2018–19): campaign ideation for Garnier, behind-the-scenes photography for Reliance Fresh and a little IPO communication for good measure.",
      ],
    },
    {
      label: "SKILLS",
      lines: [
        "Way with words: copywriting, scripts, campaign concepts, brand voice, positioning and social content.",
        "The BIG picture: creative direction, content strategy, pitches, influencer campaigns and shoot direction.",
        "Good looks, good looks aur good looks (visual): Adobe Illustrator, Photoshop, InDesign, Procreate, Premiere Pro and Final Cut Pro.",
        "Bonus skills: film and theatre writing, directing, and finding a story where others see a brief.",
      ],
    },
  ],
};

/////////////////////////////////////////////////////////////////////////////
// CONTACT — the grocery list on the fridge
/////////////////////////////////////////////////////////////////////////////
export const CONTACT = {
  reachHeading: "HUNGRY? SAME. TALK TO ME.",
  reachSub: "email, call or linkedin — whatever's warmest",
  heading: "THINGS WE NEED",
  sub: "— before we cook up something good:",
  items: [
    "Coffee. Obviously.",
    "3 AM-level hunger for ideas",
    "One brain cell (shared collectively)",
    "A brief with potential",
    "17 terrible ideas before the good one",
    "A sprinkle of God complex (ahem)",
    "NONE of that “let's make it pop” rubbish",
    "Snacks for the brainstorming session (duh)",
  ],
  cta: "ADD TO CART → CONTACT ENASHA",
};